import { useState } from 'react';
import type { LiveRoom } from './api';
import { oneliveAssets } from './assets';
import { handleLiveRoomClick } from './liveEntryGuard';
import { useLiveUiMessages } from './useLiveUiMessages';

const DEFAULT_VISIBLE = 5;

interface ChannelListProps {
  rooms: LiveRoom[];
  activeUuid?: string;
  showTitle?: boolean;
  onBack?: () => void;
  className?: string;
}

export default function ChannelList({
  rooms,
  activeUuid,
  showTitle = true,
  onBack,
  className = '',
}: ChannelListProps) {
  const liveUiMessages = useLiveUiMessages();
  const [expanded, setExpanded] = useState(false);
  const liveRooms = rooms.filter((r) => r.status === 'live');
  const visibleRooms = expanded ? liveRooms : liveRooms.slice(0, DEFAULT_VISIBLE);
  const hasMore = liveRooms.length > DEFAULT_VISIBLE;

  return (
    <div className={`onelive-channel-list ${className}`.trim()}>
      {showTitle && (
        <div className="onelive-channel-list-head">
          <h2><strong>추천채널</strong></h2>
          {onBack ? (
            <button
              type="button"
              className="onelive-gnb-toggle is-on"
              onClick={onBack}
              aria-label="닫기"
            >
              <img src={oneliveAssets.sideMenuOn} alt="" />
            </button>
          ) : null}
        </div>
      )}
      <ul className={`onelive-gnb-live${expanded ? ' is-expanded' : ''}`}>
        {visibleRooms.map((room) => (
          <li key={room.uuid}>
            <a
              href={`/live/${room.uuid}`}
              className={activeUuid === room.uuid ? 'active' : ''}
              onClick={(e) => {
                e.preventDefault();
                handleLiveRoomClick(room, liveUiMessages);
                onBack?.();
              }}
            >
              <span className="onelive-gnb-avatar">
                {room.avatar ? <img src={room.avatar} alt="" /> : <span>{room.bj_nickname?.[0]}</span>}
              </span>
              <span className="onelive-gnb-name">{room.bj_nickname}</span>
              <span className="onelive-gnb-live-badge">Live</span>
            </a>
          </li>
        ))}
      </ul>
      {hasMore && (
        <div className="onelive-gnb-more-wrap">
          <button
            type="button"
            className={`onelive-gnb-more-btn${expanded ? ' is-expanded' : ''}`}
            onClick={() => setExpanded((v) => !v)}
          >
            <span>{expanded ? '접기' : '더보기'}</span>
            <img
              src={expanded ? oneliveAssets.moreOff : oneliveAssets.moreOn}
              alt=""
              className="onelive-gnb-more-icon"
            />
          </button>
        </div>
      )}
    </div>
  );
}
